import { useEffect, useState } from "react";

/** Decorative live-viewers chip — pseudo-random count that drifts over time. */
export function LiveViewers({ className = "" }: { className?: string }) {
  const [count, setCount] = useState(() => 180 + Math.floor(Math.random() * 60));

  useEffect(() => {
    const id = setInterval(() => {
      setCount((c) => {
        const delta = Math.floor(Math.random() * 11) - 5; // -5..+5
        const next = c + delta;
        if (next < 120) return 120 + Math.floor(Math.random() * 20);
        if (next > 320) return 320 - Math.floor(Math.random() * 20);
        return next;
      });
    }, 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 backdrop-blur-md ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
      </span>
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/90">
        <span className="tabular-nums text-emerald-300">{count}</span>
        <span className="ml-1.5 text-white/60">viewing now</span>
      </span>
    </div>
  );
}
